import React from "react";
// material-ui components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
// icons
import DealIcon from "@material-ui/icons/BusinessCenter";
import Contacts from "@material-ui/icons/Contacts";
import Notes from "@material-ui/icons/Subject";
import Tasks from "@material-ui/icons/PlaylistAddCheck";
import Search from "@material-ui/icons/Search";
import Docs from "@material-ui/icons/Description";
import Chat from "@material-ui/icons/Chat";
import Build from "@material-ui/icons/Build";
import BusinessCenter from "@material-ui/icons/BusinessCenter";
// core components
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";


///
import DealsTab from './DealsTab.jsx'
import PublishedTab from './PublishedTab.jsx'
import SubscribedTab from './SubscribedTab.jsx'
import AvailableTab from './AvailableTab.jsx'

const styles = {
  textCenter: {
    textAlign: "center"
  },
  avatar: {
    width: '200px',
    height: '200px'
  },
  profile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content',
    marginBottom: "50px"
  }
};

class PropertyTabs extends React.Component{
  render(){
    const { classes } = this.props;
    const { property } = this.props;
    return (
      <div>
        <CustomTabs
          plainTabs
          headerColor="info"
          tabs={[
            {
              tabName: "Private",
              tabIcon: DealIcon,
              tabContent: (
                    <DealsTab oportunity={property} />
              )
            },
            {
              tabName: "Published",
              tabIcon: Docs,
              tabContent: (
                    <PublishedTab deal={property} />
              )
            },
            {
              tabName: "Subscribed",
              tabIcon: Tasks,
              tabContent: (
                    <SubscribedTab oportunity={property} />
              )
            },
            {
              tabName: "Available",
              tabIcon: Search,
              tabContent: (
                    <AvailableTab oportunity={property} />
              )
            }
          ]}
        />
      </div>
    );
  }
}

export default withStyles(styles)(PropertyTabs);
